import React from "react";
import ObjetivoKilos from "./ObjetivoKilos";
import ObjetivoCompradores from "./ObjetivoCompradores";

const Render = (props, context) => {
  
  return (
    <div key={("POD-" + props.id + "-" + props.category.position)} className="col-md-6 mt-30">
      <h4>{props.category.name}</h4>
      {(props.category.tipo === "1") && (
        <div className="row dflex justify-content-start">
          <div className="col-lg">
            {props.goals.map(goal => (
              <ObjetivoKilos key={("Obj"+goal.id)} goal={goal} category={props.category} />
            ))}
          </div>
        </div>
      )}
      {(props.category.tipo === "2") && (
        <div className="row dflex justify-content-start">
          <div className="col-lg">
            {props.goals.map(goal => (
              <ObjetivoCompradores key={("ObjComp"+goal.id)} goal={goal} category={props.category} />
            ))}
          </div>
        </div>
      )}
      {(props.category.tipo === "3") && (
        <div className="row dflex justify-content-start">
          <div className="col-lg border-dash">
            {props.goals.map(goal => (
              <ObjetivoKilos key={("ObjKg"+goal.id)} goal={goal} category={props.category} />
            ))}
          </div>
          <div className="separador"></div>
          <div className="col-lg">
            {props.goals.map(goal => (
              <ObjetivoCompradores key={("ObjComp"+goal.id)} goal={goal} category={props.category} />
            ))}
          </div>
        </div>
      )}
      <div className="separador"></div>
    </div>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/Home/PuntajeObjetivo.js